import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=1aa429fe"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa429fe')) {
      api.createRecord('1aa429fe', component.options)
    } else {
      api.reload('1aa429fe', component.options)
    }
    module.hot.accept("./Roles.vue?vue&type=template&id=1aa429fe", function () {
      api.rerender('1aa429fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Roles/Roles.vue"
export default component.exports